import { render, staticRenderFns } from "./_popupWrapper.vue?vue&type=template&id=bb29c51a&"
import script from "./_popupWrapper.vue?vue&type=script&lang=js&"
export * from "./_popupWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports